import { render, staticRenderFns } from "./profit-multiple.vue?vue&type=template&id=73b12361"
import script from "./profit-multiple.vue?vue&type=script&lang=js"
export * from "./profit-multiple.vue?vue&type=script&lang=js"
import style0 from "./profit-multiple.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/profit-multiple.vue
// module id = 0A03
// module chunks = 0